<mat-dialog-content>
  <div class="db-title">{{RecivedData?.title}}</div>
  <div class="d-flex">
    <kendo-datepicker (valueChange)="onDateChange($event)" [value]="RecivedData.date"
      calendarType="classic"></kendo-datepicker>
  </div>
</mat-dialog-content>
<div mat-dialog-actions class="justify-content-end pe-2 ps-2">
    <button class="btn outline" (click)="onCancelClick()">Cancel</button>
    <button class="btn ms-2" (click)="OK()">Ok</button>
</div>